import DeviceManager from '../utils/device-manager';
import Swiper from 'swiper';

export default function initCaseStudiesList() : void {
    const $caseStudiesContainers = document.querySelectorAll<HTMLElement>('.js-case-studies-list');

    $caseStudiesContainers.forEach($container => {
        new CaseStudiesList($container);
    });
}

export class CaseStudiesList {
    $container: HTMLElement;
    swiper: Swiper;

    constructor($container: HTMLElement) {
        this.$container = $container;

        const swiperParams = {
            loop: true,
            loopAdditionalSlides: 2,
            spaceBetween: 10,
            threshold: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {},
        };
        swiperParams.breakpoints[DeviceManager.devices.md] = {
            spaceBetween: 0,
        };

        this.swiper = new Swiper(this.$container, swiperParams);
    }
}
